<template>
	
	<div v-if="init" class="Countdown">
		<ul v-if="applyState == 'ing'">
				<li>
					剩余时间：
				</li>
				<li v-for="(item,index) in countDownDatas" :key="index">
					 <span class="valueBg">{{item.value}}</span>
					 <span>{{item.name}}</span>
				</li>
		</ul>
		
		<div style="opacity: 0;" class="startDate fontSize1" v-if="applyState == 'end'">
			1
		</div>
		
		<div class="startDate fontSize1" v-if="applyState == 'start'">
			{{startDate}}
		</div>
	</div>
  
</template>

<script> 
import { mapState } from 'vuex'
export default {
  name: 'Countdown',
  data(){
	  return {
		  countDownDatas : []
	  }
  },
  /*
  props : {
	  CountdownInfo : Object
  },
  */
  created(){  
		
  },
  watch : {
	  init : {
		  handler (val){
			  //console.log(['init',val,this.applyState])
			 
		  },
		  immediate : true
		  
	  },
	  applyState : {
		  handler (val){
		  		//console.log(['init',val,this.applyState])
		  		if(val && this.applyState != 'start'){
		  						this.formatTime(); 
		  		} 	 
		  },
		  immediate : true
	  }
  },
  computed: {
	  ...mapState([
  			  'endTime',
			  'startTime',
			  'init',
			  'applyState'
	]),
	startDate(){
		var d = new Date(this.startTime);
		
		return [d.getFullYear(),d.getMonth()+1,d.getDate()].join('.')+' 开始';
	}
  },
  methods: {
  	formatTime() {
		var nowTime = new Date().getTime()
  		var lefttime = parseInt((this.endTime - nowTime) / 1000);
		var d = parseInt(lefttime / (24*60*60));
		var h = parseInt(lefttime / (60 * 60) % 24);
		var m = parseInt(lefttime / 60 % 60);
		var s = parseInt(lefttime % 60);
		
		if(lefttime <= 0){
			d = h = m = s = 0;
		}
		 
		this.countDownDatas = [];
		this.countDownDatas.push({
			name : '天',
			value : d
		})
		
		this.countDownDatas.push({
			name : ':',
			value : h
		})
		
		this.countDownDatas.push({
			name : ':',
			value : m
		})
		
		this.countDownDatas.push({
			name : '',
			value : s
		})
		
		if(lefttime <= 0){
			this.$store.commit('setApplyState','end');
			return;
		}
		 
		this.time = setTimeout(() => {
			this.formatTime();
		},1000) 
	}
  },
  
  components: {
     
  },
  destroyed(){
	  if(this.time){
		  clearTimeout(this.time);
		  this.time = null;
	  }
	  
	  console.log('destroyed  countdown')
  }
}
</script>

<style>
	.Countdown{
		/* background-image: url('./../assets/圆角矩形 732.png');*/
		 background-size: 100% auto;
		 background-repeat: no-repeat;
		 line-height: 0.294736rem;
		 color: #fff;
	}
	
	.Countdown .valueBg{
		background-image: url('./../assets/圆角矩形 2 拷贝 2.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		
	}
	
	
	.Countdown span{
		width: 0.147368rem;
		height: 0.126315rem;
		padding: 0.026315rem;
		color: #fff;
	}
	
	.Countdown ul{
		display: flex;
		justify-content:center;
	}
	
	.Countdown li{
		
		
	}
	
	.startDate{
		color: #fff;
		display: flex;
		justify-content:center;
	}
</style>
